import React, { useState } from "react";
import { Link } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PopupSearch from "../components/PopupSearch";
import ScrollToTop from "../components/ScrollToTop";

import {
  FaUser,
  FaHeart,
  FaShoppingBag,
  FaMapMarkerAlt,
  FaSignOutAlt,
} from "react-icons/fa";

const MyOrders = () => {
   const [menuOpen, setMenuOpen] =  useState(false);
  return (
    <>
     <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />

      <main className="main">

        <Header />

        {/* CSS */}
        <link
          rel="stylesheet"
          href="/assets/css/Myorders.css"
        />

        {/* BREADCRUMB */}
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage:
              "url('/assets/img/bg/breadcumb-bg-1.jpg')",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >

          <img
            src="/assets/img/shapes/dot-shape.svg"
            alt="dot"
            className="breadcumb-element"
          />

          <div className="container">

            <div className="breadcumb-content">

              <h1 className="breadcumb-title">
                My Orders
              </h1>

              <div className="breadcumb-menu-wrap">

                <ul className="breadcumb-menu">

                  <li>
                    <Link to="/">Home</Link>
                  </li>

                  <li>
                    My Orders
                  </li>

                </ul>

              </div>

            </div>

          </div>

        </div>

        {/* MAIN SECTION */}
        <section className="space-top space-extra-bottom">

          <div className="container">

            <div className="row g-4">

              {/* SIDEBAR */}
              <div className="col-lg-3">

                <div className="account-sidebar">

                  {/* USER */}
                  <div className="account-user text-center">

                    <div className="account-avatar">

                      <img
                        src="/assets/img/author/author-1-1.png"
                        alt="User"
                      />

                    </div>

                    <h5>
                      Priya Sharma
                    </h5>

                    <p>
                      priya@email.com
                    </p>

                  </div>

                  {/* NAVIGATION */}
                  <ul className="account-nav">

                    <li>
                      <Link
                        to="/my-account"
                        className="account-nav__link"
                      >
                        <FaUser />
                        My Profile
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/my-orders"
                        className="account-nav__link active"
                      >
                        <FaShoppingBag />
                        My Orders
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/wishlist"
                        className="account-nav__link"
                      >
                        <FaHeart />
                        Wishlist
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/address"
                        className="account-nav__link"
                      >
                        <FaMapMarkerAlt />
                        Addresses
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/login"
                        className="account-nav__link logout-link logout-link"
                      >
                        <FaSignOutAlt />
                        Logout
                      </Link>
                    </li>

                  </ul>

                </div>

              </div>

              {/* RIGHT CONTENT */}
              <div className="col-lg-9">

                <div className="orders-content">

                  {/* TOPBAR */}
                  <div className="orders-topbar">

                    <h2>
                      My Orders
                    </h2>

                    <select>
                      <option>
                        All Orders
                      </option>

                      <option>
                        Delivered
                      </option>

                      <option>
                        Shipped
                      </option>
                    </select>

                  </div>

                  {/* ORDER 1 */}
                  <div className="single-order">

                    <div className="order-header">

                      <div className="left">

                        <h4>
                          Order #NS-1045
                        </h4>

                        <span>
                          Placed: 20 Apr 2026
                        </span>

                      </div>

                      <button className="status delivered">
                        DELIVERED
                      </button>

                    </div>

                    <div className="products-row">

                      <div className="product-item">

                        <img
                          src="/assets/img/product3/product-s-1-1.png"
                          alt=""
                        />

                        <div>

                          <p className="diamond">
                            Petal Perfection Ring
                          </p>

                          <p>
                            Qty: 1 | ₹4,500
                          </p>

                        </div>

                      </div>

                      <div className="product-item">

                        <img
                          src="/assets/img/product3/product-s-1-3.png"
                          alt=""
                        />

                        <div>

                          <p className="diamond">
                            Diamond Stud Earrings
                          </p>

                          <p>
                            Qty: 1 | ₹6,800
                          </p>

                        </div>

                      </div>

                    </div>

                    <div className="order-footer">

                      <h3>
                        Total: ₹11,300
                      </h3>

 <div className="d-flex gap-2 flex-wrap">

  {/* TRACK ORDER */}
  <Link
    to="/track-order"
    className="vs-btn style2 track-order"
  >
    Track Order
  </Link>

  {/* BUY AGAIN */}
 

  {/* CANCEL ORDER */}
  <Link
    to="/Cancelorder"
    className="vs-btn style2 track-order cancel-btn"
  >
  Cancel Order
  </Link>
   <Link
    to="/shop-details"
    className="vs-btn"
  >
  
    Buy Again
  </Link>

</div>

                    </div>

                  </div>

                  {/* ORDER 2 */}
                  <div className="single-order">

                    <div className="order-header">

                      <div className="left">

                        <h4>
                          Order #NS-1038
                        </h4>

                        <span>
                          Placed: 05 Apr 2026
                        </span>

                      </div>

                      <button className="status shipped">
                        SHIPPED
                      </button>

                    </div>

                    <div className="products-row">

                      <div className="product-item">

                        <img
                          src="/assets/img/product3/product-s-1-2.png"
                          alt=""
                        />

                        <div>

                          <p className="diamond">
                            Golden Chain Necklace
                          </p>

                          <p>
                            Qty: 1 | ₹8,200
                          </p>

                        </div>

                      </div>

                    </div>

                    <div className="order-footer">

                      <h3>
                        Total: ₹8,200
                      </h3>
<div className="d-flex gap-2 flex-wrap">

  <Link
    to="/track-order"
    className="vs-btn style2 track-order"
  >
    Track Order
  </Link>
  <Link
    to="/Cancelorder"
    className="vs-btn style2 track-order cancel-btn"
  >
  Cancel Order
  </Link>

  <Link
    to="/shop-details"
    className="vs-btn"
  >
    Buy Again
  </Link>

</div>


                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </section>

        <Footer />

      </main>

      <ScrollToTop />
    </>
  );
};

export default MyOrders;